<template>
  <div class="medical-detail-cntainer">
    <TopBg
      title="门诊APG管理系统"
      sub-title="门诊医保“打包付费”与医院精细化管理的新型医保支付工具。"
      :bg="topBg"
    />
    <div class="main-content page">
      <!-- 产品简介 -->
      <div class="section">
        <div class="title">产品简介</div>
        <div class="rows-2">
          <info-item-vue
            title="产品背景"
            desc="本产品的推出是响应国家及地方层面深化医保支付方式改革的明确要求。近年来，一系列重要政策文件为门诊支付改革指明了方向：《“十四五”全民医疗保障规划》 提出要深化门诊支付方式改革，规范门诊付费基本单元；《关于进一步完善医疗卫生服务体系的意见》 鼓励探索将签约居民的医保门诊统筹基金按人头支付给基层医疗卫生机构；国家医疗保障局2025年办法 要求积极探索门诊支付方式改革，形成多元复合医保支付新格局；地方试点（如济宁市） 已经明确提出建立总额预算控制下基于大数据病种的按门诊病组分组（APG）结合点数法付费的目标。这些政策表明，医疗机构的运营模式正从事后按项目付费，转向事前预算管理下的按价值付费。门诊APG管理系统正是在此背景下，为帮助医疗机构主动适应这一重大变革、确保在新时代下的生存与发展而设计的必备工具。"
          >
            <template #icon>
              <img src="../../../assets/bj.svg" alt="" />
            </template>
          </info-item-vue>
          <info-item-vue
            title="产品概述"
            desc="门诊APG管理系统是一款深度融合于医院信息系统（HIS）的智能管理平台。其核心目标是利用APG（门诊病组）分组原理，将医保支付的“事后审核”转变为诊疗过程中的“事前预测”与“事中干预”。该系统通过实时计算引擎，在医生开具诊断和治疗时，模拟出该病例将归入哪个APG组及其对应的预估支付标准与盈亏情况。它如同一位内置在医生工作站中的“医保精算师”，以直观的“红绿灯”（绿色结余/红色亏损）形式为医生提供决策支持，引导其选择最合理、最经济的诊疗方案，从而在保障医疗质量的前提下，有效控制医疗成本，避免医保超支。"
          >
            <template #icon>
              <img src="../../../assets/gs.svg" alt="" />
            </template>
          </info-item-vue>
        </div>
      </div>
      <!-- 解决方案 -->
      <div class="section">
        <div class="title">解决方案</div>
        <div class="rows-3">
          <solution-item
            title="高性能双模引擎"
            desc="采用“实时流处理+批量任务处理”的架构，确保医生操作时获得毫秒级的分组响应，同时保证历史数据计算的完整性，为系统稳定性和实时性奠定基石。"
          >
            <template #icon>
              <img src="./assets/solution01.svg" alt="" />
            </template>
          </solution-item>
          <solution-item
            title="分组模拟与盈亏反馈"
            desc="医生在HIS中勾选诊断与操作后，可一键触发分组模拟。系统返回预测结果，并以鲜明的“红绿灯”颜色标识盈亏状态，支持方案对比优化，引导医生选择最优路径。"
          >
            <template #icon>
              <img src="./assets/solution02.svg" alt="" />
            </template>
          </solution-item>
          <solution-item
            title="嵌入式医生助手"
            desc="系统无感集成于HIS，提供诊断编码智能推荐、操作缺项实时提醒、分组结果实时反馈等功能。医生无需额外培训即可上手，实现“赋能临床不增负”的目标。"
          >
            <template #icon>
              <img src="./assets/solution03.svg" alt="" />
            </template>
          </solution-item>
        </div>
        <div class="rows-3 mt-16">
          <solution-item
            title="编码与费用双轨质控"
            desc="在病案形成阶段即进行事前干预，通过同一规则引擎，并行检查编码问题（如医保灰码、性别冲突）和费用合规问题（如超支风险、低倍率病例），守住分组准确与合规底线。"
          >
            <template #icon>
              <img src="./assets/solution04.svg" alt="" />
            </template>
          </solution-item>
          <solution-item
            title="低代码规则自定义"
            desc="提供图形化配置器，允许医院管理员通过拖拽方式自定义规则，并可进行A/B测试，使医院能快速响应政策变化，具备自主进化能力。"
          >
            <template #icon>
              <img src="./assets/solution05.svg" alt="" />
            </template>
          </solution-item>
          <solution-item
            title="交互式管理驾驶舱"
            desc="为管理层提供全局数据视图，支持从医院整体到科室、医生、具体病例的多层级下钻分析，一键导出数据，实现从洞察到行动的闭环管理。"
          >
            <template #icon>
              <img src="./assets/solution06.svg" alt="" />
            </template>
          </solution-item>
        </div>
      </div>

      <!-- 产品价值 -->
      <div class="section">
        <div class="title">产品价值</div>
        <div class="rows-4">
          <value-item-vue
            title="战略合规与风险规避"
            desc="直接帮助医院满足国家及地方医保支付改革要求，从被动应对转向主动适应，显著降低因诊疗方案不合理导致的医保拒付或超支风险。"
          >
            <template #icon>
              <img src="./assets/value01.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue
            title="临床行为优化"
            desc="将成本控制意识前置到每一位医生的诊疗决策环节，通过智能引导促进临床路径的规范化与合理化，从源头上提升医疗资源的利用效率。"
          >
            <template #icon>
              <img src="./assets/value02.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue
            title="精细化管理提升"
            desc="为医院管理者提供数据驱动的决策支持，能够精准定位问题科室、病种或医生，实现精细化的绩效管理和资源配置，推动医院内部运营效率的持续改进。"
          >
            <template #icon>
              <img src="./assets/value03.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue
            title="无缝落地与高可用性"
            desc="“嵌入式”设计确保医生接受度高，上线两周使用率可达90%以上。高性能架构保障了系统在高并发场景下的稳定运行，不影响正常诊疗秩序。"
          >
            <template #icon>
              <img src="./assets/value04.svg" alt="" />
            </template>
          </value-item-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../../common/TopBg.vue";
import infoItemVue from "../../common/info-item.vue";
import valueItemVue from "../../common/value-item.vue";
import SolutionItem from "../../common/solution-item.vue";

export default {
  name: "DrgPlatform",
  components: {
    TopBg,
    infoItemVue,
    valueItemVue,
    SolutionItem,
  },
  data() {
    return {
      topBg: require("./assets/bg.png"),
    };
  },
};
</script>
